import 'css-chunksrc/client/pages/projectPage/synthesisPage/taskSection/styles.scss';export default {
  "section": "_section_k0bhv_1",
  "heading": "_heading_k0bhv_11",
  "title": "_title_k0bhv_19",
  "main": "_main_k0bhv_25",
  "iconBox": "_iconBox_k0bhv_31",
  "icon": "_icon_k0bhv_31",
  "displayToggle": "_displayToggle_k0bhv_44"
};